import Vue from 'vue';
// Domain
import { InvestorProfileStateManager } from '@/modules/flagship/investor-profile/investor-profile/domain/state/investor-profile-state-manager';
import InvestorProfileState from '@/modules/flagship/investor-profile/investor-profile/domain/state/investor-profile-state';

import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class InvestorProfileVueStateManager implements InvestorProfileStateManager {
  // eslint-disable-next-line max-len
  private _state: InvestorProfileState = Vue.observable<InvestorProfileState>(new InvestorProfileState());

  private readonly observers: Observer[] = [];

  get state(): InvestorProfileState {
    return this._state;
  }

  set state(value: InvestorProfileState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<InvestorProfileState>) {
    type Keys = keyof InvestorProfileState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
